import React, { FC } from 'react';
import style from './style.module.less';
import { Button, Dialog } from '@galaxy-ds/core';
import { useTranslation } from 'react-i18next';

interface Props {
  isOpen: boolean;
  title: string;
  children: React.ReactNode;
  onClose: () => void;
  confirm?: {
    text?: string;
    onClick: () => void;
  };
  cancel?: {
    text?: string;
    onClick?: () => void;
  };
}

export const ActionModal: FC<Props> = (props) => {
  const { isOpen, onClose, title, children } = props;
  const { t } = useTranslation();

  return (
    <Dialog
      title={title}
      open={isOpen}
      variant='alert'
      message={children}
      handleClose={onClose}
      PaperProps={{ className: style.paper }}
      // for some odd reason gds-modal gds-modal--desktop MuiModal-root  are not present when we set classname
      className={`gds-modal gds-modal--desktop MuiModal-root ${style.dialog}`}
    >
      <div className={style.container}>
        {props.confirm ? (
          <Button
            variant='contained'
            color='primary'
            onClick={props.confirm.onClick}
            className={style.button}
          >
            {props.confirm.text ?? t('confirm.confirm')}
          </Button>
        ) : null}
        <Button
          variant='outlined'
          onClick={props.cancel?.onClick ?? onClose}
          className={style.button}
        >
          {props.cancel?.text ?? t('confirm.cancel')}
        </Button>
      </div>
    </Dialog>
  );
};
